export enum VerifiedBadgeType {
  VERIFIED = 'verified.svg',
  PARTIALLY_VERIFIED = 'partially-verified-v3.svg',
}
